import { Stack, Typography } from "@mui/material";

import { Shared_FormTemplate_QuestionTypeTextFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeTextFragment>;
    value: string | null | undefined;
};

export default function QuestionTextDisplay({ field, value }: Props) {
    return (
        <Stack>
            <Typography variant="caption" color="text.secondary">
                {field.name}
            </Typography>
            <Typography sx={{ whiteSpace: field.type.multiline ? "pre-wrap" : "normal" }}>{value || "—"}</Typography>
        </Stack>
    );
}
